import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"
import { ScrollToPlugin } from "gsap/ScrollToPlugin"

gsap.registerPlugin(ScrollToPlugin);

export default class extends Controller {
  // static targets = [ "navicon", "naviconLine", "overlay", "megaMenu", "megaMenuInner", "menu", "mobileNavDrawer" ]

  initialize() {
    this.menuTls = new Array()
    this.setupMenuTls()
  }

  setupMenuTls(){
    this.menuTls = new Array()
    this.element.querySelectorAll('.faq-item').forEach((el,i)=>{
      this.menuTls[i] = gsap.timeline({
        paused: true,
        onComplete:()=>{
          gsap.to(window,{
            scrollTo: {
              y: document.querySelector('.product-info'),
            }
          })
        }
      })
      .to(el.querySelector('svg'),{
        rotate:45,
        duration:.25
      },'show')
      
      .from(el.querySelector('.rich-text'),{
        height:0,
        autoAlpha:0,
        duration:.25
      },'show')

      if(i === 0){
        this.menuTls[i].progress(1)
      }
    })
  }

  toggleDrawer(event){
    let currentIndex = event.target.closest('header').getAttribute('data-index')
    currentIndex = parseInt(currentIndex)
    this.menuTls.forEach((tl, i)=>{
      if(i == currentIndex){
        setTimeout(()=>{
          this.menuTls[i].play()
        },250)
      }else{
        this.menuTls[i].reverse()
      }
    })
  }
}